<template>

    <div class="notice" :class="classes">
        <div class="notice-body">
            <div v-if="icon" class="notice-icon" :style="{ color: color }"><i :class="icon" /></div>
            <div v-if="title && url" class="notice-title"><a v-html="title" :href="url" target="_blank" /></div>
            <div v-else-if="title" class="notice-title" v-html="title" />
            <div v-if="text" class="notice-text" v-html="text" />
        </div>
        <div v-if="$slots['default']" class="notice-footer">
            <slot></slot>
        </div>
    </div>

</template>

<style scoped lang="scss">

    .notice {
        align-items: center;
        background: $color-white;
        color: $color-text;
        display: flex;
        flex-direction: column;
        padding: 60px;
        text-align: center;
        transition: background-color .3s;
        width: 100%;
        &.notice-sm {
            padding: 30px;
            .notice-icon {
                font-size: 20px;
                height: 60px;
                width: 60px;
            }
            .notice-title {
                font-size: 14px;
            }
        }
    }

    .notice-bordered {
        border: 1px solid $color-rule;
        border-radius: 5px;
    }

    .notice-clickable {
        cursor: pointer;
        &:hover {
            background: $color-bg;
        }
    }

    .notice-icon {
        background: $color-bg;
        border: 1px solid $color-rule;
        border-radius: 20px;
        color: $color-primary;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-size: 40px;
        width: 120px;
        height: 120px;
        margin-bottom: 15px;
        transition: border .3s;
    }

    .notice-title {
        @include font-semibold(18px);
        color: $color-text;
        line-height: 1.6em;
        margin: 0 0 10px 0;
        max-width: map-get($grid-breakpoints, 'sm');
        a {
            color: $color-text;
            text-decoration: none;
            &:hover {
                text-decoration: underline;
            }
        }
    }

    .notice-text {
        @include font-regular(16px);
        color: $color-text;
        line-height: 1.6em;
        margin: 0 0 10px 0;
        max-width: map-get($grid-breakpoints, 'sm');
    }

    .notice-body {
        *:only-child {
            margin-bottom: 0;
        }
    }

    .notice-footer {
        padding-top: 15px;
    }

    .notice-danger {
        border-color: $color-danger;
        .notice-icon, .notice-title, .notice-text {
            color: $color-danger;
        }
    }

    .notice-success {
        border-color: $color-success;
        .notice-icon, .notice-title, .notice-text {
            color: $color-success;
        }
    }

</style>

<script>

export default {

    props: {
        icon: {
            type: String,
        },
        size: {
            type: String,
            default: 'md',
        },
        title: {
            type: String,
        },
        text: {
            type: String,
        },
        url: {
            type: String,
        },
        type: {
            type: String,
        },
        color: {
            type: String,
        },
        bordered: {
            type: Boolean,
            default: true,
        },
        clickable: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        classes() {
            return {
                'notice-sm': this.size === 'sm',
                'notice-md': this.size === 'md',
                'notice-danger': this.type === 'danger',
                'notice-success': this.type === 'success',
                'notice-bordered': this.bordered,
                'notice-clickable': this.clickable,
            }
        },

    },

}

</script>
